import LogFactory, { type C9Logger, type LogLevels } from 'c9-js-log-client';
import { type ReactElement, createContext, useContext, useEffect, useMemo } from 'react';

/* ============================================ Exported Types ============================================ */
export type TLogLevels = keyof typeof LogLevels;

export type TLoggerFunction = (error: any, payload?: any) => void;

export type TLoggerContext = C9Logger;

/* ============================================ Local Types ============================================ */
type TLoggerContextProviderWrapper = {
  values: [logEndpoint: string, appName: string, logLevel?: TLogLevels];
  children: ReactElement;
};

/* ============================================ Main Component ============================================ */
const LoggerContext = createContext<TLoggerContext>({} as TLoggerContext);

export const LoggerContextProvider = ({
  values: [logEndpoint, appName, logLevel],
  children
}: TLoggerContextProviderWrapper) => {
  const logger = useMemo(() => LogFactory(logEndpoint, appName, logLevel), [logEndpoint, appName, logLevel]);

  useEffect(() => {
    logger.debug(`Starting up application ${logger.appName}`);
  }, [logger]);

  return <LoggerContext.Provider value={logger}>{children}</LoggerContext.Provider>;
};

export const useLoggerContext = () => useContext(LoggerContext);
